import { render, staticRenderFns } from "./card-actions.vue?vue&type=template&id=22711142&scoped=true"
import script from "./card-actions.vue?vue&type=script&lang=js"
export * from "./card-actions.vue?vue&type=script&lang=js"
import style0 from "./card-actions.vue?vue&type=style&index=0&id=22711142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22711142",
  null
  
)

export default component.exports